import ApiManager from '../../api/crud-manager';
import jsonToView from '../../api/json-to-view';

class RealTimePrice {
  constructor(options = {}) {
    this.config = {
      moduleList: () => document.querySelectorAll('[data-module="RealTimePrice"]'),
      apiManager: new ApiManager(),
      ...options
    };
  }

  // fetch product price based on product id
  async getPrice(productId) {
    const { apiManager } = this.config;

    const url = `/api/v2/catalog/product/${productId}/prices`;

    return apiManager.get(url).then(data => data);
  }

  init() {
    const { moduleList } = this.config;

    moduleList().forEach(_module => {
      const module = _module;

      const {
        productId,
        hasChildren,
        pricesExTax,
        resourceErrorMessage,
        initialized
      } = module.dataset;

      if (!productId && (initialized != null && initialized)) return;

      module.dataset.initialized = true; // skip initialized module items
      module.classList.add('is-loading');

      this.getPrice(productId)
        .then(response => {
          // eslint-disable-next-line no-underscore-dangle
          const { prices } = response._embedded;

          const templateView = 'RealTimePrice';
          const viewData = {
            price: prices.length ? prices[0] : null,
            hasChildren,
            pricesExTax,
            fromPrice: module.dataset.fromPrice || '0'
          };

          // create view based on template file
          jsonToView(viewData, templateView)
            .then(html => {
              module.classList.remove('is-loading');
              module.innerHTML = html;
            })
            .catch(error => {
              module.classList.remove('is-loading');
              module.innerHTML = resourceErrorMessage || 'Price not available';
              throw new Error(error);
            });
        })
        .catch(error => {
          module.classList.remove('is-loading');
          module.innerHTML = resourceErrorMessage || 'Price not available';
          throw new Error(error);
        });
    });
  }
}

export default RealTimePrice;
